import { accOpeningActions, localStateManagementActions } from '../../../shared/Actions';
import { connect } from 'react-redux';
import MarketEmploymentInfoCard from './MarketEmploymentInfoCard';

const mapStateToProps = (state /* , props */) => ({
    accOpeningData: state.accOpeningReducerData,
    initialState: state.initialAppData,
    masterLookupStateData: state.transactionCompositeDataReducerData,
    localStateData: state.localStateManagementReducerData,
});

const mapDispatchToProps = {
    ...accOpeningActions,
    ...localStateManagementActions,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(MarketEmploymentInfoCard);
